<script setup lang="ts">
import Lightbox from '@/helpers/website/content-builder/light-box';
import { onMounted } from 'vue';

const lightbox = new Lightbox();

onMounted(() => {
  lightbox.init();
});
</script>

<style lang="scss">
@use '@/styles/website/content-builder/light-box.scss' as *;
</style>
